import Select from "react-select";

/**
 * Global fix สำหรับ react-select ทุกจุดในโปรเจค
 *
 * ปัญหา: เมื่อ <Select> อยู่ภายใน react-modal (content มี overflow: auto)
 * เมนู dropdown จะถูกพื้นที่ของ modal "กลืน"/ตัด (clip) จนมองไม่เห็น
 *
 * วิธีแก้: render เมนูออกไปไว้ที่ document.body (menuPortalTarget) เพื่อให้
 * หลุดออกจาก overflow ของ modal และตั้ง zIndex ของ menuPortal ให้สูงกว่า
 * overlay ของ modal (overlay zIndex = 1050 ใน ModalStyle.js)
 *
 * ทำเป็น monkey-patch ที่ default export ของ react-select จุดเดียว
 * จึงมีผลกับทุก <Select> ในโปรเจคโดยไม่ต้องแก้ทีละไฟล์ และยังคง
 * เคารพ props ที่แต่ละ component ส่งมาเอง (override ได้ปกติ)
 */
const MENU_PORTAL_Z_INDEX = 1100; // > modal overlay (1050)

const originalRender = Select.render;

if (originalRender && !Select.__portalPatched) {
  Select.render = function patchedSelectRender(props, ref) {
    const userStyles = props.styles || {};

    const mergedProps = {
      // ค่า default — component ยัง override ได้ผ่าน ...props ด้านล่าง
      menuPortalTarget: typeof document !== "undefined" ? document.body : null,
      menuPosition: "fixed",
      ...props,
      styles: {
        ...userStyles,
        // บังคับ zIndex ของ portal ให้สูงกว่า modal overlay เสมอ
        // โดยยังคง style menuPortal เดิมที่ component อาจกำหนดไว้
        menuPortal: (base, state) => {
          const fromUser = userStyles.menuPortal
            ? userStyles.menuPortal(base, state)
            : base;
          return { ...fromUser, zIndex: MENU_PORTAL_Z_INDEX };
        },
      },
    };

    return originalRender(mergedProps, ref);
  };

  Select.__portalPatched = true;
}
